import React, { useState } from 'react'
import { Modal, Input } from 'antd'
import { useTranslation } from 'react-i18next'
import styles from './style.module.scss'
import { basicColors } from 'utils/ui'
import ColorButton from 'pages/calendar/components/common/ColorButton'

interface CategoryEditorProps {
  onClose: () => void
  onSave: (data: any, completion: (success: boolean) => void) => void
  initialData?: any
}

const CategoryEditor: React.FC<CategoryEditorProps> = ({ onClose, onSave, initialData }) => {
  const { t } = useTranslation()
  const [name, setName] = useState(initialData?.name || '')
  const [selectedColor, setSelectedColor] = useState(
    initialData?.color
      ? `#${initialData.color}`
      : basicColors[Math.floor(Math.random() * basicColors.length)],
  )

  const handleSave = () => {
    if (!name.trim()) return

    onSave(
      {
        ...(initialData ? initialData : {}),
        name: name.trim(),
        color: selectedColor.replace('#', ''),
      },
      (success) => {
        if (success) {
          onClose()
        }
      },
    )
  }

  const handleColorSelect = (color: string) => {
    setSelectedColor(color)
  }

  return (
    <Modal
      title={initialData ? t('contact.menu.manageCategory') : t('contact.menu.newCategory')}
      open={true}
      closable={false}
      footer={null}
      width={400}
      className={styles.modal}
      centered
    >
      <div className={styles.container}>
        <div className={styles.formGroup}>
          <label className={styles.label}>{t('contact.menu.name')}</label>
          <div className={styles.inputWrapper}>
            <Input
              placeholder={t('contact.menu.name')}
              value={name}
              onChange={(e) => setName(e.target.value)}
              className={styles.input}
            />
          </div>
        </div>

        <div className={styles.colorSelector}>
          <ColorButton color={selectedColor} showName={true} onChange={handleColorSelect} />
        </div>

        <div className={styles.footer}>
          <button className={styles.cancelButton} onClick={onClose}>
            {t('common.button.cancel')}
          </button>
          <button
            className={`${styles.saveButton} ${!name.trim() ? styles.disabled : ''}`}
            onClick={handleSave}
            disabled={!name.trim()}
          >
            {t('common.button.ok')}
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default CategoryEditor
